import Flex from "@/shared/components/common/Flex";
import Typography from "@/shared/components/common/Typography";

import {
  Airplane,
  AirTrafficControl,
  City,
  MapPinSimpleArea,
} from "@phosphor-icons/react/dist/ssr";

interface AirportSearchProps {
  airports: AirportCity & { type: "city" | "airport" };
  onClick: (value: {
    name: string;
    id: string | number;
    type: string | undefined;
    code: string;
  }) => void;
}

export default function AirportSearch({
  airports: { airports, iata, id, lang_name, name, type },
  onClick,
}: AirportSearchProps) {
  return (
    <Flex className="w-full flex-col gap-y-2">
      <Flex
        className="w-full justify-start items-center gap-x-2 cursor-pointer hover:bg-muted dark:hover:bg-muted/10 transition-all duration-150 py-1 rounded-xs px-1"
        onClick={() =>
          onClick({
            name: lang_name,
            id,
            type: "city",
            code: airports[0].iata,
          })
        }
      >
        <MapPinSimpleArea className="text-primary" />
        <Typography className="font-medium">{lang_name}</Typography>
      </Flex>

      <Flex className="flex-col">
        {airports.map(({ lang_name, id, iata }) => (
          <Flex
            className="w-full justify-start items-center gap-x-2 px-3 cursor-pointer hover:bg-muted dark:hover:bg-muted/10 transition-all duration-150 py-1 rounded-xs"
            key={`${lang_name}-${id}`}
            onClick={() =>
              onClick({
                name: lang_name,
                id,
                type: "airport",
                code: iata,
              })
            }
          >
            <AirTrafficControl className="text-primary" />
            <Typography className="font-normal text-muted-foreground">
              {lang_name}
            </Typography>
          </Flex>
        ))}
      </Flex>
    </Flex>
  );
}
